import { RESET_STATE } from 'store/global/actions';

import { LOAN_APPLICATION_ACTION_TYPE } from '../actions';

const initialState = null;

const generatedFormReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_APPLICATION_ACTION_TYPE.GENERATE_FORM:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default generatedFormReducer;
